import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import APIService from 'services/APIService'
import OnwardSharingCheckbox from 'components/OnwardSharingCheckbox'
import SkeletonBar from 'components/SkeletonBar'

const api = APIService()

const appliesNoteFor = organisation => `Requests for this document go to ${organisation ? `${organisation}’s` : 'the uploader’s organisation’s'} approvers.`

const FileOnwardSharingField = ({ bpId, fileId, onChange }) => {
  const [state, setState] = useState({ status: 'loading', summary: null })
  const [value, setValue] = useState(true)

  useEffect(() => {
    let cancelled = false
    setState({ status: 'loading', summary: null })
    api
      .get(`/building-passport/${bpId}/files/${fileId}/onward-sharing`)
      .then(resp => {
        if (cancelled) return
        const summary = resp?.data?.data ?? null
        setValue(Boolean(summary?.allowed))
        setState({ status: summary ? 'ready' : 'failed', summary })
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'failed', summary: null })
      })
    return () => {
      cancelled = true
    }
  }, [bpId, fileId])

  if (state.status === 'failed') return null
  if (state.status === 'loading') {
    return (
      <Skeleton aria-hidden='true'>
        <SkeletonBar $width='45%' />
        <SkeletonBar $width='90%' />
      </Skeleton>
    )
  }

  const { summary } = state
  const handleChange = next => {
    setValue(next)
    onChange && onChange(next === Boolean(summary.allowed) ? null : next)
  }

  return (
    <OnwardSharingCheckbox
      checked={value}
      onChange={handleChange}
      disabled={!summary.canChange}
      lockedByFolder={summary.lockedByFolder}
      appliesNote={summary.applies === false ? appliesNoteFor(summary.decidedByOrganisation) : null}
      viewerIsUploader={summary.isUploader === true}
    />
  )
}

export default FileOnwardSharingField

const Skeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
